import { j as r } from "../../../../node_modules/react/jsx-runtime.js";
import { clsx as S } from "../../../../node_modules/clsx/dist/clsx.m.js";
import { useState as N, useMemo as V } from "react";
import $ from "../../Icon/Icon.js";
import { Typography as O } from "../../Typography/Typography.js";
import P from "../../../molecules/Dropdown/Dropdown.js";
import q from "../../ListItem/ListItem.js";
import z from "../../../molecules/Dropdown/components/NoResultMessage.js";
import n from "./style.module.scss.js";
import { i18n as k } from "../../../../utils/locale/locale.js";
import A from "../TextField.js";
const y = ({
  dropdownSide: h,
  listItems: p,
  onChange: T,
  size: g = "regular",
  testId: m,
  value: f,
  valueKey: t = "value",
  labelKey: e = "text",
  subLabelKey: a = "helperText",
  avatarSrcKey: j = "avatarSrc",
  groupKey: E,
  readOnly: c = !1
}) => {
  const [d, M] = N(""), [F, x] = N(!1), u = p.find((o) => (o == null ? void 0 : o[t]) === f), w = V(
    () => p.filter(
      (o) => {
        var s, i, C, I, l, v, D, L;
        return ((I = (i = (s = o == null ? void 0 : o[e]) == null ? void 0 : s.toLowerCase) == null ? void 0 : (C = i.call(s)).includes) == null ? void 0 : I.call(C, d.toLowerCase())) || ((L = (v = (l = o == null ? void 0 : o[a]) == null ? void 0 : l.toLowerCase) == null ? void 0 : (D = v.call(l)).includes) == null ? void 0 : L.call(D, d.toLowerCase()));
      }
    ),
    [p, d, e, a]
  ), R = (o) => {
    if (c)
      return o.preventDefault();
    x(!0);
  };
  return /* @__PURE__ */ r.jsx(
    P,
    {
      withPortal: !0,
      position: `bottom-${h}`,
      onClose: () => x(!1),
      dropDownElement: /* @__PURE__ */ r.jsxs(
        "div",
        {
          className: S(n.list, n[h], n[g], {
            [n.textFilled]: !!f,
            [n.readOnly]: c
          }),
          role: "button",
          tabIndex: 0,
          onClick: R,
          onKeyDown: (o) => {
            c && o.preventDefault(), (o.key === "Enter" || o.key === " ") && x(!0);
          },
          children: [
            /* @__PURE__ */ r.jsx(
              O,
              {
                text: (u == null ? void 0 : u[e]) || k("select"),
                textColor: "color/fg/default",
                variant: g === "regular" ? "interface/medium/sm" : "interface/medium/s"
              }
            ),
            /* @__PURE__ */ r.jsx(
              $,
              {
                name: "chevron-down",
                size: "sm",
                className: n.icon,
                style: {
                  transform: F ? "rotate(180deg)" : "rotate(0deg)"
                }
              }
            )
          ]
        }
      ),
      onClickListItem: T,
      testId: `${m}-dropdown`,
      valueKey: t,
      labelKey: e,
      subLabelKey: a,
      avatarSrcKey: j,
      groupKey: E,
      readOnly: c,
      children: /* @__PURE__ */ r.jsxs("div", { className: "max-h-[260px] overflow-y-auto py-025 top-0", children: [
        /* @__PURE__ */ r.jsx("div", { className: "py-075 px-150", children: /* @__PURE__ */ r.jsx(
          A,
          {
            leadingIcon: "search-sm",
            onChange: M,
            placeholder: k("search")
          }
        ) }),
        w.map((o, s) => /* @__PURE__ */ r.jsx(
          q,
          {
            helperText: o == null ? void 0 : o[a],
            leadingIcon: o.leadingIcon,
            selected: (o == null ? void 0 : o[t]) === f,
            text: o == null ? void 0 : o[e],
            avatarSrc: o == null ? void 0 : o[j],
            value: o == null ? void 0 : o[t]
          },
          s
        )),
        w.length === 0 && /* @__PURE__ */ r.jsx(z, {})
      ] })
    }
  );
};
export {
  y as default
};
//# sourceMappingURL=List.js.map
